/**
 * Opens a Blob file in a new browser tab.
 * Creates a temporary object URL and opens it in a new window.
 * Optionally sets the document title of the new tab as a best-effort filename hint
 * (subject to browser same-origin restrictions).
 *
 * @param blob - The file content as a Blob
 * @param fileName - Optional title/name hint for the new tab
 */
export const openBlobInNewTab = (
  blob: Blob | null,
  fileName?: string
): void => {
  if (blob) {
    const objectUrl = URL.createObjectURL(blob)
    const newTab = window.open(objectUrl, '_blank')

    if (newTab && fileName) {
      newTab.document.title = fileName
    }
  } else {
    console.error('Opening blob in new tab failed due to empty payload.')
  }
}

/**
 * Opens a URL string in a new browser tab.
 *
 * @param url - The URL to open
 */
export const openUrlInNewTab = (url: string): void => {
  window.open(url, '_blank')
}
